// This is a non-exhaustive list of status codes
// The fill list can be found at:
// https://docs.beefree.io/tracking-message-changes/#complete-event-chart

export enum BeeResponseCode {
  RowDropped = '1400',
  RowDragged = '1401',
  RowDeleted = '1402',
}

export interface BeeCallbackResponse {
  code: BeeResponseCode | string;
  description: string;
  value: string;
  patches: Record<string, any>[];
}
